<template>
  <div>
    <v-data-table
      :headers="headers"
      mobile-breakpoint="0"
      :items="busStudentTrackings"
      :server-items-length="totalCount"
      :items-per-page="10"
      item-key="id"
      loading-text="Đang Tải"
      :loading="loading"
      sort-by="title"
      no-data-text="Không có dữ liệu"
      disable-sort
      @pagination="paginationChange"
    >
      <template v-slot:[`item.student`]="{ item }">
        <CardStudentName :student="item.student" link />
      </template>
      <template v-slot:[`item.class`]="{ item }">
        {{ get(item, 'class.title', '') }}
      </template>
      <template v-slot:[`item.driver`]="{ item }">
        <router-link style="text-decoration: none" :to="'/teacher/' + get(item, 'buses.0.driver.id')">
          {{ get(item, 'bus.driver.name') }}
        </router-link>
      </template>
      <template v-slot:[`item.driverPhone`]="{ item }">
        {{ get(item, 'bus.phone') }}
      </template>
      <template v-slot:[`item.headTeacher`]="{ item }">
        <router-link style="text-decoration: none" :to="'/teacher/' + get(item, 'headTeacher.id')">
          {{ get(item, 'headTeacher.name') }}
        </router-link>
      </template>
      <template v-slot:[`item.headTeacherPhone`]="{ item }">
        {{ get(item, 'headTeacher.phone') }}
      </template>
      <template v-slot:[`item.status`]="{ item }">
        <div class="d-flex align-center">
          <div>{{ item.bus_schedule | getBusTimeline }}:</div>
          <v-chip class="ml-3" small label :color="item.status | getAttendanceStatusColor" dark>
            <span class="mr-1">
              {{ item.status | getBusStudentAttendanceStatus }}
            </span>
            <span>{{ getTimeStatus(item) }} </span>
          </v-chip>
        </div>
      </template>
      <template v-slot:[`item.register`]="{ item }">
        <div>
          <v-chip small label :color="item.register | getRegisterBusColor" dark>
            <span class="mr-1">
              {{ item.register | getRegisterBusText }}
            </span>
          </v-chip>
        </div>
      </template>
      <template v-slot:[`item.action`]="{ item }">
        <BusStudentAttendanceListActions :studentTrackingId="item.id" />
      </template>
    </v-data-table>
  </div>
</template>

<script>
import BusStudentAttendanceListActions from '@/modules/bus/BusStudentAttendanceListActions.vue'
import CardStudentName from '@/components/basic/card/CardStudentName.vue'
import { headers } from './BusStudentTrackingTable/helper'
import { mapActions, mapMutations, mapState } from 'vuex'
import { get } from 'lodash'

export default {
  components: { BusStudentAttendanceListActions, CardStudentName },
  data() {
    return {
      headers,
      get
    }
  },
  computed: {
    ...mapState({
      busStudentTrackings: state => state.busStudentTracking.busStudentTrackings,
      totalCount: state => state.busStudentTracking.totalCount,
      loading: state => state.busStudentTracking.loading,
      query: state => state.busStudentTracking.query
    })
  },

  methods: {
    ...mapActions({
      fetch: 'busStudentTracking/fetch',
      count: 'busStudentTracking/count'
    }),
    ...mapMutations({
      setState: 'busStudentTracking/setState',
      setLoading: 'busStudentTracking/setLoading'
    }),
    async paginationChange(pagination) {
      try {
        this.setState({ attribute: 'loading', data: true })
        const start = (pagination.page - 1) * pagination.itemsPerPage
        const limit = pagination.itemsPerPage
        await this.fetch({ ...this.query, _start: start, _limit: limit })
      } catch (error) {
        this.$alert.error(error)
      } finally {
        this.setState({ attribute: 'loading', data: false })
      }
    },
    getTimeStatus(item) {
      if (item.status === 'attendance') {
        return item.timeCheckIn ? ' - ' + moment(Number.parseInt(item.timeCheckIn)).format('LT') : ''
      } else if (item.status === 'left') {
        return item.timeCheckOut ? ' - ' + moment(Number.parseInt(item.timeCheckOut)).format('LT') : ''
      } else return ''
    }
  }
}
</script>

<style lang="scss" scoped>
.border {
  border-bottom: 1px solid lightgray;
}
</style>
